import { render, staticRenderFns } from "./NewOrderNotice.vue?vue&type=template&id=b0cd0df4&scoped=true"
import script from "./NewOrderNotice.vue?vue&type=script&lang=js"
export * from "./NewOrderNotice.vue?vue&type=script&lang=js"
import style0 from "./NewOrderNotice.vue?vue&type=style&index=0&id=b0cd0df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cd0df4",
  null
  
)

export default component.exports